import { ColumnProps } from 'refactored/components/Common/Table';
import Roles from 'enums/users/roles.enum';

const getAllowedColumns = (columns: ColumnProps[], userRoles: Roles[]) =>
  columns.filter(({ allowedRoles }) =>
    userRoles?.some((role) => allowedRoles?.includes(role)),
  );

export default getAllowedColumns;
